import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const CauseDetails = () => {
    const [cause, setCause] = useState(null);
    const { id } = useParams(); // Extract cause ID from URL
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        const fetchCauseDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes/${id}`);
                
                setCause(response.data); // Set cause data
            } catch (error) {
                console.error('Error fetching cause details:', error);
            }
        };

        fetchCauseDetails();
    }, [id]);

    if (!cause) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-xl text-gray-600">Loading...</div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            {/* Content Section */}
            <div className="bg-white px-4 py-8 md:px-8 lg:px-16 xl:px-24 w-full max-w-5xl mx-auto rounded-lg shadow-lg">
                <div className="flex justify-between items-center">
                    <h1 className="text-3xl font-bold text-gray-800">{cause.name}</h1>
                    <button
                        onClick={() => navigate(-1)} // Navigate back to the previous page
                        className="text-red-500 text-xl  font-bold"
                    >
                        ✕
                    </button>
                </div>
                <p className="text-lg text-gray-700 mt-4">{cause.description}</p>
                
                {/* Show all images of the cause */}
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {cause.images && cause.images.length > 0 ? (
                        cause.images.map((image, index) => (
                            <div key={index} className="w-full h-64 overflow-hidden rounded-lg shadow-md">
                                <img
                                    src={`data:image/jpeg;base64,${image}`}
                                    alt={`Cause Image ${index + 1}`}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-600">No images available for this cause.</p>
                    )}
                </div>

                {/* Show QR Code if available */}
                {cause.qrImage && (
                    <div className="mt-6 flex justify-center">
                        <img
                            src={`data:image/jpeg;base64,${cause.qrImage}`}
                            alt="QR Code"
                            className="w-32 h-full object-cover shadow-md"
                        />
                    </div>
                )}

                <div className="mt-8 text-center">
                    <button className="px-8 py-3 text-white bg-green-500 hover:bg-green-700 rounded-lg transition duration-300">
                        Donate
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CauseDetails;
